/* 🤖 this file was generated by script */
export const wiconDocumentError = {
  name: 'document_error',
  data: `<svg viewBox="0 0 20 20"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M11.5 3H5v14h10v-7"/><path fill="currentColor" fill-rule="evenodd" d="M14 6.87c0-.28.22-.5.5-.5a.5.5 0 110 1 .5.5 0 01-.5-.5z" clip-rule="evenodd"/><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="M14.5 2v3m-7.47 7.03H13M7 10h2.5M7 14.07h6"/></svg>`,
};
